import MaillotJaune from '../img/jerseys/tours/120px-Jersey_yellow.svg.png';
import MaillotVert from '../img/jerseys/tours/120px-Jersey_darkgreen.svg.png';
import MaillotVertBright from '../img/jerseys/tours/120px-Jersey_green.svg.png';
import MaillotBlanc from '../img/jerseys/tours/120px-Jersey_white.svg.png';
import Polkadot from '../img/jerseys/tours/120px-Jersey_polkadot.svg.png';
import MagliaCiclamino from '../img/jerseys/tours/120px-Jersey_ciclamino.svg.png';
import MagliaRosa from '../img/jerseys/tours/120px-Jersey_pink.svg.png';
import MagliaAzzurra from '../img/jerseys/tours/120px-Jersey_blue.svg.png';
import MagliaNera from '../img/jerseys/tours/120px-Jersey_black.svg.png';
import MaillotRojo from '../img/jerseys/tours/120px-Jersey_red.svg.png';
import MaillotLunares from '../img/jerseys/tours/120px-Jersey_bluedots.svg.png';
import Gold from '../img/jerseys/tours/70px-Jersey_gold.svg.png';
import Orange from '../img/jerseys/tours/80px-Jersey_orange.svg.png';
import Cyan from '../img/jerseys/tours/120px-Jersey_cyan.svg.png';
import LightBlue from '../img/jerseys/tours/120px-Jersey_light_blue.svg.png';
import Violet from '../img/jerseys/tours/Jersey_violet.png';
import Teal from '../img/jerseys/tours/Jersey_teal.png';
import Salmon from '../img/jerseys/tours/Jersey_salmon.png';
import WhiteGreenLines from '../img/jerseys/tours/70px-Jersey_green_lines_volta.svg.png';
import GreenWhiteDots from '../img/jerseys/tours/80px-Jersey_green_white_dots.svg.png';
import YellowBlueBar from '../img/jerseys/tours/70px-Jersey_yellow-bluebar.svg.png';
import RedNumber from '../img/jerseys/tours/120px-Jersey_red_number.svg.png';
import YellowNumber from '../img/jerseys/tours/120px-Jersey_yellow_number.svg.png';
import RedLantern from '../img/jerseys/tours/redlantern.png';
import C4FLeader from '../img/jerseys/others/wr1.gif';
import WCRoad from '../img/jerseys/others/WCJerseyIcon.png';
import OCRoad from '../img/jerseys/others/ocroad.png';
import WCITT from '../img/jerseys/others/WCJerseyIcon.png';
import ECRoad from '../img/jerseys/others/ECJerseyIcon.png';

import AndesGC from '../img/jerseys/tours/CdlA GC leader jersey.png';
import AndesMountain from '../img/jerseys/tours/CdlA mountain jersey.png';
import AndesPoints from '../img/jerseys/tours/CdlA points jersey.png';
import AndesYouth from '../img/jerseys/tours/CdlA youth jersey.png';

import NCFrance from '../img/jerseys/nationalChampions/NCFrance.png';
import NCAustria from '../img/jerseys/nationalChampions/NCAustria.png';
import NCAustralia from '../img/jerseys/nationalChampions/NCAustralia.png';
import NCBelgium from '../img/jerseys/nationalChampions/NCBelgium.png';
import NCBarbados from '../img/jerseys/nationalChampions/NCBarbados.png';
import NCBurkinaFaso from '../img/jerseys/nationalChampions/NCBurkinaFaso.png';
import NCBulgaria from '../img/jerseys/nationalChampions/NCBulgaria.png';
import NCBosniaHerzegovina from '../img/jerseys/nationalChampions/NCBosniaHerzegovina.png';
import NCBolivia from '../img/jerseys/nationalChampions/NCBolivia.png';
import NCBrazil from '../img/jerseys/nationalChampions/NCBrazil.png';
import NCBahamas from '../img/jerseys/nationalChampions/NCBahamas.png';
import NCBelize from '../img/jerseys/nationalChampions/NCBelize.png';
import NCCuba from '../img/jerseys/nationalChampions/NCCuba.png';
import NCCameroon from '../img/jerseys/nationalChampions/NCCameroon.png';
import NCCanada from '../img/jerseys/nationalChampions/NCCanada.png';
import NCCostaRica from '../img/jerseys/nationalChampions/NCCostaRica.png';
import NCSwitzerland from '../img/jerseys/nationalChampions/NCSwitzerland.png';
import NCColombia from '../img/jerseys/nationalChampions/NCColombia.png';
import NCCzechRepublic from '../img/jerseys/nationalChampions/NCCzechRepublic.png';
import NCGermany from '../img/jerseys/nationalChampions/NCGermany.png';
import NCDenmark from '../img/jerseys/nationalChampions/NCDenmark.png';
import NCAlgeria from '../img/jerseys/nationalChampions/NCAlgeria.png';
import NCSpain from '../img/jerseys/nationalChampions/NCSpain.png';
import NCEcuador from '../img/jerseys/nationalChampions/NCEcuador.png';
import NCEstonia from '../img/jerseys/nationalChampions/NCEstonia.png';
import NCEgypt from '../img/jerseys/nationalChampions/NCEgypt.png';
import NCEritrea from '../img/jerseys/nationalChampions/NCEritrea.png';
import NCEthiopia from '../img/jerseys/nationalChampions/NCEthiopia.png';
import NCFinland from '../img/jerseys/nationalChampions/NCFinland.png';
import NCLiechtenstein from '../img/jerseys/nationalChampions/NCLiechtenstein.png';
import NCUnitedKingdom from '../img/jerseys/nationalChampions/NCUnitedKingdom.png';
import NCGreece from '../img/jerseys/nationalChampions/NCGreece.png';
import NCHungary from '../img/jerseys/nationalChampions/NCHungary.png';
import NCCroatia from '../img/jerseys/nationalChampions/NCCroatia.png';
import NCItaly from '../img/jerseys/nationalChampions/NCItaly.png';
import NCIsrael from '../img/jerseys/nationalChampions/NCIsrael.png';
import NCIndia from '../img/jerseys/nationalChampions/NCIndia.png';
import NCIran from '../img/jerseys/nationalChampions/NCIran.png';
import NCIreland from '../img/jerseys/nationalChampions/NCIreland.png';
import NCIceland from '../img/jerseys/nationalChampions/NCIceland.png';
import NCJapan from '../img/jerseys/nationalChampions/NCJapan.png';
import NCJamaica from '../img/jerseys/nationalChampions/NCJamaica.png';
import NCKazakhstan from '../img/jerseys/nationalChampions/NCKazakhstan.png';
import NCLuxembourg from '../img/jerseys/nationalChampions/NCLuxembourg.png';
import NCLithuania from '../img/jerseys/nationalChampions/NCLithuania.png';
import NCLatvia from '../img/jerseys/nationalChampions/NCLatvia.png';
import NCMalaysia from '../img/jerseys/nationalChampions/NCMalaysia.png';
import NCMorocco from '../img/jerseys/nationalChampions/NCMorrocco.png';
import NCMoldavia from '../img/jerseys/nationalChampions/NCMoldavia.png';
import NCMexico from '../img/jerseys/nationalChampions/NCMexico.png';
import NCNorway from '../img/jerseys/nationalChampions/NCNorway.png';
import NCNepal from '../img/jerseys/nationalChampions/NCNepal.png';
import NCNetherlands from '../img/jerseys/nationalChampions/NCNetherlands.png';
import NCNewZealand from '../img/jerseys/nationalChampions/NCNewZealand.png';
import NCPortugal from '../img/jerseys/nationalChampions/NCPortugal.png';
import NCPeru from '../img/jerseys/nationalChampions/NCPeru.png';
import NCPoland from '../img/jerseys/nationalChampions/NCPoland.png';
import NCParaguay from '../img/jerseys/nationalChampions/NCParaguay.png';
import NCArgentina from '../img/jerseys/nationalChampions/NCArgentina.png';
import NCChina from '../img/jerseys/nationalChampions/NCChina.png';
import NCChile from '../img/jerseys/nationalChampions/NCChile.png';
import NCIndonesia from '../img/jerseys/nationalChampions/NCIndonesia.png';
import NCRomania from '../img/jerseys/nationalChampions/NCRomania.png';
import NCUruguay from '../img/jerseys/nationalChampions/NCUruguay.png';
import NCRussia from '../img/jerseys/nationalChampions/NCRussia.png';
import NCSweden from '../img/jerseys/nationalChampions/NCSweden.png';
import NCSlovakia from '../img/jerseys/nationalChampions/NCSlovakia.png';
import NCSouthKorea from '../img/jerseys/nationalChampions/NCSouthKorea.png';
import NCSlovenia from '../img/jerseys/nationalChampions/NCSlovenia.png';
import NCSenegal from '../img/jerseys/nationalChampions/NCSenegal.png';
import NCTaiwan from '../img/jerseys/nationalChampions/NCTaipei.png';
import NCTunisia from '../img/jerseys/nationalChampions/NCTunisia.jpeg';
import NCTurkey from '../img/jerseys/nationalChampions/NCTurkey.png';
import NCTuvalu from '../img/jerseys/nationalChampions/NCTuvalu.png';
import NCUkraine from '../img/jerseys/nationalChampions/NCUkraine.png';
import NCUnitedStates from '../img/jerseys/nationalChampions/NCUnitedStates.png';
import NCUzbekistan from '../img/jerseys/nationalChampions/NCUzbekistan.png';
import NCVietnam from '../img/jerseys/nationalChampions/NCVietnam.png';
import NCVanuatu from '../img/jerseys/nationalChampions/NCVanuatu.png';
import NCBelarus from '../img/jerseys/nationalChampions/NCBelarus.png';
import NCSerbia from '../img/jerseys/nationalChampions/NCSerbia.png';
import NCVenezuela from '../img/jerseys/nationalChampions/NCVenezuela.png';
import NCSouthAfrica from '../img/jerseys/nationalChampions/NCSouthAfrica.png';
import NCZimbabwe from '../img/jerseys/nationalChampions/NCZimbabwe.png';

export const tourJerseyMapping = [
    {
        tourName: 'GIRO', jerseys: [
            { type: 'GCLeader', picture: MagliaRosa },
            { type: 'Sprint', picture: MagliaCiclamino },
            { type: 'Mountain', picture: MagliaAzzurra },
            { type: 'Youth', picture: MaillotBlanc },
            { type: 'RedLantern', picture: RedLantern },
            { type: 'MostActive', picture: RedNumber },
            { type: 'Team', picture: YellowNumber }]
    },
    {
        tourName: 'Le Tour', jerseys: [
            { type: 'GCLeader', picture: MaillotJaune },
            { type: 'Sprint', picture: MaillotVert },
            { type: 'Mountain', picture: Polkadot },
            { type: 'Youth', picture: MaillotBlanc },
            { type: 'RedLantern', picture: RedLantern },
            { type: 'MostActive', picture: RedNumber },
            { type: 'Team', picture: YellowNumber }]
    },
    {
        tourName: 'La Vuelta', jerseys: [
            { type: 'GCLeader', picture: MaillotRojo },
            { type: 'Sprint', picture: MaillotVertBright },
            { type: 'Mountain', picture: MaillotLunares },
            { type: 'Youth', picture: MaillotBlanc },
            { type: 'RedLantern', picture: RedLantern },
            { type: 'MostActive', picture: YellowNumber },
            { type: 'Team', picture: YellowNumber }]
    },
    {
        tourName: 'Suisse', jerseys: [
            { type: 'GCLeader', picture: Gold },
            { type: 'Sprint', picture: MagliaNera },
            { type: 'Mountain', picture: MaillotRojo },
            { type: 'Youth', picture: MaillotBlanc },
            { type: 'RedLantern', picture: RedLantern },
            { type: 'MostActive', picture: RedNumber },
            { type: 'Team', picture: YellowNumber }]
    },
    {
        tourName: 'Dauphine', jerseys: [
            { type: 'GCLeader', picture: YellowBlueBar },
            { type: 'Sprint', picture: MaillotVert },
            { type: 'Mountain', picture: MaillotRojo },
            { type: 'Youth', picture: MaillotBlanc },
            { type: 'RedLantern', picture: RedLantern },
            { type: 'MostActive', picture: RedNumber },
            { type: 'Team', picture: YellowNumber }]
    },
    {
        tourName: 'Catalunya', jerseys: [
            { type: 'GCLeader', picture: WhiteGreenLines },
            { type: 'Sprint', picture: MaillotBlanc },
            { type: 'Mountain', picture: Polkadot },
            { type: 'Youth', picture: MagliaAzzurra },
            { type: 'RedLantern', picture: RedLantern },
            { type: 'MostActive', picture: RedNumber },
            { type: 'Team', picture: YellowNumber }]
    },
    {
        tourName: 'Down Under', jerseys: [
            { type: 'GCLeader', picture: Orange },
            { type: 'Sprint', picture: MagliaAzzurra },
            { type: 'Mountain', picture: GreenWhiteDots },
            { type: 'Youth', picture: MaillotBlanc },
            { type: 'RedLantern', picture: RedLantern },
            { type: 'MostActive', picture: RedNumber },
            { type: 'Team', picture: YellowNumber }]
    },
    {
        tourName: 'Algarve', jerseys: [
            { type: 'GCLeader', picture: MaillotJaune },
            { type: 'Sprint', picture: MaillotVert },
            { type: 'Mountain', picture: MagliaAzzurra },
            { type: 'Youth', picture: MaillotBlanc },
            { type: 'RedLantern', picture: RedLantern },
            { type: 'MostActive', picture: RedNumber },
            { type: 'Team', picture: YellowNumber }]
    },
    {
        tourName: 'UAE Tour', jerseys: [
            { type: 'GCLeader', picture: MaillotRojo },
            { type: 'Sprint', picture: MaillotVert },
            { type: 'Mountain', picture: Polkadot },
            { type: 'Youth', picture: MaillotBlanc },
            { type: 'RedLantern', picture: RedLantern },
            { type: 'MostActive', picture: RedNumber },
            { type: 'Team', picture: YellowNumber }]
    },
    {
        tourName: 'Paris Nimes', jerseys: [
            { type: 'GCLeader', picture: MaillotJaune },
            { type: 'Sprint', picture: MaillotVert },
            { type: 'Mountain', picture: Polkadot },
            { type: 'Youth', picture: MaillotBlanc },
            { type: 'RedLantern', picture: RedLantern },
            { type: 'MostActive', picture: RedNumber },
            { type: 'Team', picture: YellowNumber }]
    },
    {
        tourName: 'Tirreno', jerseys: [
            { type: 'GCLeader', picture: MagliaAzzurra },
            { type: 'Sprint', picture: MagliaCiclamino },
            { type: 'Mountain', picture: MaillotVert },
            { type: 'Youth', picture: MaillotBlanc },
            { type: 'RedLantern', picture: RedLantern },
            { type: 'MostActive', picture: RedNumber },
            { type: 'Team', picture: YellowNumber }]
    },
    {
        tourName: 'Pais Vasco', jerseys: [
            { type: 'GCLeader', picture: MaillotJaune },
            { type: 'Sprint', picture: MaillotVert },
            { type: 'Mountain', picture: Polkadot },
            { type: 'Youth', picture: MagliaAzzurra },
            { type: 'RedLantern', picture: RedLantern },
            { type: 'MostActive', picture: RedNumber },
            { type: 'Team', picture: RedNumber }]
    },
    {
        tourName: 'Tour of the Alps', jerseys: [
            { type: 'GCLeader', picture: MaillotVert },
            { type: 'Sprint', picture: MaillotRojo },
            { type: 'Mountain', picture: Cyan },
            { type: 'Youth', picture: MaillotBlanc },
            { type: 'RedLantern', picture: RedLantern },
            { type: 'MostActive', picture: RedNumber },
            { type: 'Team', picture: YellowNumber }]
    },
    {
        tourName: 'Tour de Romandie', jerseys: [
            { type: 'GCLeader', picture: MaillotVertBright },
            { type: 'Sprint', picture: Orange },
            { type: 'Mountain', picture: LightBlue },
            { type: 'Youth', picture: MaillotBlanc },
            { type: 'RedLantern', picture: RedLantern },
            { type: 'MostActive', picture: RedNumber },
            { type: 'Team', picture: YellowNumber }]
    },
    {
        tourName: 'Austria Tour', jerseys: [
            { type: 'GCLeader', picture: MaillotRojo },
            { type: 'Sprint', picture: MaillotVert },
            { type: 'Mountain', picture: MaillotBlanc },
            { type: 'Youth', picture: MagliaNera },
            { type: 'RedLantern', picture: RedLantern },
            { type: 'MostActive', picture: RedNumber },
            { type: 'Team', picture: YellowNumber }]
    },
    {
        tourName: 'Pologne', jerseys: [
            { type: 'GCLeader', picture: MaillotJaune },
            { type: 'Sprint', picture: MaillotBlanc },
            { type: 'Mountain', picture: MaillotLunares },
            { type: 'Youth', picture: MaillotBlanc },
            { type: 'RedLantern', picture: RedLantern },
            { type: 'MostActive', picture: MagliaAzzurra },
            { type: 'Team', picture: YellowNumber }]
    },
    {
        tourName: 'Burgos', jerseys: [
            { type: 'GCLeader', picture: Violet },
            { type: 'Sprint', picture: MaillotVert },
            { type: 'Mountain', picture: MaillotRojo },
            { type: 'Youth', picture: MaillotBlanc },
            { type: 'RedLantern', picture: RedLantern },
            { type: 'MostActive', picture: RedNumber },
            { type: 'Team', picture: YellowNumber }]
    },
    {
        tourName: 'Arctic Tour', jerseys: [
            { type: 'GCLeader', picture: MaillotJaune },
            { type: 'Sprint', picture: MaillotVert },
            { type: 'Mountain', picture: Salmon },
            { type: 'Youth', picture: MaillotBlanc },
            { type: 'RedLantern', picture: RedLantern },
            { type: 'MostActive', picture: RedNumber },
            { type: 'Team', picture: YellowNumber }]
    },
    {
        tourName: 'Binckbank Tour', jerseys: [
            { type: 'GCLeader', picture: MagliaAzzurra },
            { type: 'Sprint', picture: Teal },
            { type: 'Mountain', picture: Polkadot },
            { type: 'Youth', picture: MaillotBlanc },
            { type: 'RedLantern', picture: RedLantern },
            { type: 'MostActive', picture: MaillotBlanc },
            { type: 'Team', picture: YellowNumber }]
    },
    {
        tourName: 'Campeonato de los Andes', jerseys: [
            { type: 'GCLeader', picture: AndesGC },
            { type: 'Sprint', picture: AndesPoints },
            { type: 'Mountain', picture: AndesMountain },
            { type: 'Youth', picture: AndesYouth },
            { type: 'RedLantern', picture: RedLantern },
            { type: 'MostActive', picture: RedNumber },
            { type: 'Team', picture: YellowNumber }]
    }];


export function getJersey(tourName, jerseyType) {
    if (typeof jerseyType !== 'string' || jerseyType === null || jerseyType === 0) return null;
    if (jerseyType.match(/^NC/)) {
        switch (jerseyType) {

            case 'NC_AT': return NCAustria;
            case 'NC_AU': return NCAustralia;
            case 'NC_BE': return NCBelgium;
            case 'NC_BB': return NCBarbados;
            case 'NC_BF': return NCBurkinaFaso;
            case 'NC_BG': return NCBulgaria;
            case 'NC_BA': return NCBosniaHerzegovina;
            case 'NC_BO': return NCBolivia;
            case 'NC_BR': return NCBrazil;
            case 'NC_BS': return NCBahamas;
            case 'NC_BZ': return NCBelize;
            case 'NC_CU': return NCCuba;
            case 'NC_CM': return NCCameroon;
            case 'NC_CA': return NCCanada;
            case 'NC_CR': return NCCostaRica;
            case 'NC_CH': return NCSwitzerland;
            case 'NC_CO': return NCColombia;
            case 'NC_CZ': return NCCzechRepublic;
            case 'NC_DE': return NCGermany;
            case 'NC_DK': return NCDenmark;
            case 'NC_DZ': return NCAlgeria;
            case 'NC_ES': return NCSpain;
            case 'NC_EC': return NCEcuador;
            case 'NC_EE': return NCEstonia;
            case 'NC_EG': return NCEgypt;
            case 'NC_ER': return NCEritrea;
            case 'NC_ET': return NCEthiopia;
            case 'NC_FR': return NCFrance;
            case 'NC_FI': return NCFinland;
            case 'NC_LI': return NCLiechtenstein;
            case 'NC_GB': return NCUnitedKingdom;
            case 'NC_GR': return NCGreece;
            case 'NC_HU': return NCHungary;
            case 'NC_HR': return NCCroatia;
            case 'NC_IT': return NCItaly;
            case 'NC_IL': return NCIsrael;
            case 'NC_IN': return NCIndia;
            case 'NC_IR': return NCIran;
            case 'NC_IE': return NCIreland;
            case 'NC_IS': return NCIceland;
            case 'NC_JP': return NCJapan;
            case 'NC_JM': return NCJamaica;
            case 'NC_KZ': return NCKazakhstan;
            case 'NC_LU': return NCLuxembourg;
            case 'NC_LT': return NCLithuania;
            case 'NC_MY': return NCMalaysia;
            case 'NC_LV': return NCLatvia;
            case 'NC_MA': return NCMorocco;
            case 'NC_MD': return NCMoldavia;
            case 'NC_MX': return NCMexico;
            case 'NC_NO': return NCNorway;
            case 'NC_NP': return NCNepal;
            case 'NC_NL': return NCNetherlands;
            case 'NC_NZ': return NCNewZealand;
            case 'NC_PT': return NCPortugal;
            case 'NC_PE': return NCPeru;
            case 'NC_PL': return NCPoland;
            case 'NC_PY': return NCParaguay;
            case 'NC_AR': return NCArgentina;
            case 'NC_CN': return NCChina;
            case 'NC_CL': return NCChile;
            case 'NC_ID': return NCIndonesia;
            case 'NC_RO': return NCRomania;
            case 'NC_UY': return NCUruguay;
            case 'NC_RU': return NCRussia;
            case 'NC_SE': return NCSweden;
            case 'NC_SK': return NCSlovakia;
            case 'NC_KR': return NCSouthKorea;
            case 'NC_SI': return NCSlovenia;
            case 'NC_SN': return NCSenegal;
            case 'NC_TW': return NCTaiwan;
            case 'NC_TN': return NCTunisia;
            case 'NC_TR': return NCTurkey;
            case 'NC_TV': return NCTuvalu;
            case 'NC_UA': return NCUkraine;
            case 'NC_US': return NCUnitedStates;
            case 'NC_UZ': return NCUzbekistan;
            case 'NC_VN': return NCVietnam;
            case 'NC_VU': return NCVanuatu;
            case 'NC_BY': return NCBelarus;
            case 'NC_RS': return NCSerbia;
            case 'NC_VE': return NCVenezuela;
            case 'NC_ZA': return NCSouthAfrica;
            case 'NC_ZW': return NCZimbabwe;
            default: return null;
        }
    }

    if (jerseyType === 'C4FLeader') return C4FLeader;
    if (jerseyType === 'WCRoad') return WCRoad;
    if (jerseyType === 'WCITT') return WCITT;
    if (jerseyType === 'ECRoad') return ECRoad;
    if (jerseyType === 'OCRoad') return OCRoad;

    let tour = tourJerseyMapping.find(tour => tour.tourName === tourName);
    if (typeof tour === 'undefined')
        tour = tourJerseyMapping.find(tour => tour.tourName === 'Le Tour');

    let jersey = tour.jerseys.find(jersey => jersey.type === jerseyType);
    if (typeof jersey !== 'undefined') return jersey.picture;
    else return null;
}

export function isCustomTourJersey(tourName) {
    return tourJerseyMapping.some(tour => tour.tourName === tourName);
}

